export default "__VITE_ASSET__BuBMICiF__"